import { useQuery } from '@tanstack/vue-query'
import { getKnowledgeBaseConfig, KnowledgeBaseConfig } from '@/api/config'

export function useKnowledgeBaseQuery() {
  return useQuery({
    queryKey: ['knowledge-base'],
    queryFn: async (): Promise<KnowledgeBaseConfig> => {
      const res = await getKnowledgeBaseConfig()
      return { qbo: res.data.qbo }
    },
    staleTime: 10 * 60 * 1000,
  })
}
